/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
if ( typeof window.novatio === 'undefined' ) {
    window.novatio = {};
}

require('./bootstrap');
import CustomUtils from '../_include/utils';
window.CustomUtils = CustomUtils;

$(document).ready(function () {
    require('gijgo/js/gijgo.min.js');
    require('./modules/bootstrap-show-password');
    require('./modules/various');
    require('./modules/application');
    require('./modules/application-select-form');
    require('./modules/application-select-form-immigration');
    require('./modules/widget-generator');
    require('./modules/fixed-sidebar');
    require('./modules/disable-resend-confirmation-link');
    require('./modules/checklist');
    require('./modules/confirm');
    require('../admin/modules/select2');
    require('./bs-form-validation');
    require('./legalisation-widget');
    require('./passport-widget');
    require('./modules/FixedBanner.js')
    $('body').bind('cut copy', function(e) {
        e.preventDefault();
    });
});
